
/**
 * IsToFixed 小数保留
 * @param num 需要处理的数字
 * @param digit 数位， 要*多少，默认1 ， 10， 100， 1000
 * @param fixed 保留几位小数 默认0 0,1,2
 */
export const IsToFixed = (num: number, digit = 1, fixed = 0): number => +((num * digit).toFixed(fixed))

/**
 *isPercentageStr 百分比字符串
 * @param IsToFixed
 */
export const isPercentageStr = (IsToFixed: Function): string => IsToFixed + '%'
